// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-carousel__item{height:15.625vw;width:26.042vw}.el-carousel__item:nth-child(2n){background-color:#99a9bf}.el-carousel__item:nth-child(odd){background-color:#d3dce6}", ""]);
// Exports
module.exports = exports;
